import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";

import Form from "./Form";

import { useAdminContext } from "../../../../contexts/AdminContext";

export default function ModalForm() {
  const { dispatch, actions, state } = useAdminContext();

  return (
    <>
      <Modal
        className="student inmodal auto without-overflow"
        show={state.showModal}
        onHide={() => actions.hideModal(dispatch)}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {state.currentUser == null ? "Create Admin" : "Edit Admin"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form />
        </Modal.Body>
      </Modal>
    </>
  );
}
